import { colors } from '@styles/vars'
import styled from 'styled-components'

export default styled.div<{ readOnly?: boolean }>`
    ${props => props.readOnly ? `display: none` : `
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px;
        background: white;
        border-bottom: 2px dashed ${colors.border};
    `}
`